"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredData = getFilteredData;
var utils_1 = require("./utils");
var filterFunctions = {
    status: function (item, searchValue) {
        var statusMeta = (0, utils_1.getColumnText)('status', item);
        return !!(statusMeta &&
            searchValue &&
            statusMeta.toLowerCase().includes(searchValue.toLowerCase()));
    },
    updatedAt: function (item, searchValue) {
        var updatedAtMeta = (0, utils_1.getColumnText)('updatedAt', item);
        return !!(updatedAtMeta &&
            searchValue &&
            updatedAtMeta.includes(searchValue));
    },
    publishedAt: function (item, searchValue) {
        var meta = (0, utils_1.getMeta)(item);
        var statusMeta = (0, utils_1.getStringMetaValue)('bid-status-meta', meta);
        var publishedAtMeta = (0, utils_1.getColumnText)('publishedAt', item);
        return !!(statusMeta &&
            statusMeta === 'Published' &&
            publishedAtMeta &&
            searchValue &&
            publishedAtMeta.includes(searchValue));
    },
    description: function (item, searchValue) {
        var value = (0, utils_1.getColumnText)('description', item);
        return !!(searchValue &&
            value &&
            value.toLowerCase().includes(searchValue.toLowerCase()));
    },
    name: function (item, searchValue) {
        var value = (0, utils_1.getColumnText)('name', item);
        return !!(searchValue &&
            value &&
            value.toString().toLowerCase().includes(searchValue.toLowerCase()));
    },
    id: function (item, searchValue) {
        var value = (0, utils_1.getColumnText)('id', item);
        return !!(searchValue &&
            value &&
            value.toString().toLowerCase().includes(searchValue.toLowerCase()));
    }
};
function getFilteredData(list, searchString, filters) {
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (searchString.length > 0) {
            return list.filter(function (item) {
                return item.name.toLowerCase().includes(searchString.toLowerCase()) ||
                    item.id.toString().includes(searchString);
            });
        }
        return list;
    }
    return list.filter(function (item) {
        return keys.every(function (filterName) {
            return filterFunctions[filterName]
                ? filterFunctions[filterName](item, filters[filterName] || '')
                : true;
        });
    });
}
